import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-jobs-list-2',
  templateUrl: 'list-2.component.html'
})
export class JobsListTwoComponent {

  @Input() item: any;
  @Input() setting: any;
  @Input() full: boolean;

}
